<template>
  <div class="login-container">
    <div class="login-content">
      <div class="login-header">
        <img src="../assets/logo.png" alt="Logo" class="logo" v-if="false">
        <h1>说点悄悄话吧</h1>
        <p class="subtitle">野生程序员开发的在线聊天室</p>
      </div>
      
      <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            placeholder="请输入您的昵称"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入与他人约定好的聊天室密码"
            show-password
            prefix-icon="el-icon-lock"
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            @click="handleLogin" 
            :loading="loading" 
            class="login-btn"
          >
            进入聊天室
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-footer">
        <p>提示：1.输入相同密码才可进入相同的聊天室；2.不保存聊天记录，退出后重新进看不到之前的记录；3.若没有小伙伴陪你聊天，可输入1234进公共聊天室，但是里面可能会有陌生人，请注意言辞文明聊天</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  methods: {
    ...mapMutations(['SET_TOKEN']),
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            // 构建 FormData 对象
            const formData = new FormData();
            formData.append('username', this.loginForm.username || 'user');
            formData.append('password', this.loginForm.password);

            // 向后端 /token 接口发送 POST 请求
            const response = await axios.post('https://chat.xiaoesoft.top/api/token', formData);

            // 检查响应状态码，如果成功则保存 token 并跳转
            if (response.status === 200 && response.data && response.data.access_token) {
              // 将token保存到Vuex中
              this.SET_TOKEN(response.data.access_token);
              
              this.$router.push('/chat');
            } else {
              // 处理登录失败的情况
              this.$message.error(response.data.detail || '登录失败');
            }
          } catch (error) {
            console.error('Login error:', error);
            if (error.response && error.response.data && error.response.data.detail) {
                this.$message.error('登录失败: ' + error.response.data.detail);
            } else {
                this.$message.error('登录请求出错，请稍后重试');
            }
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #409EFF 0%, #36D1DC 100%);
  padding: 20px;
}

.login-content {
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.login-header h1 {
  font-size: 24px;
  color: #303133;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 14px;
  color: #909399;
}

.login-form {
  margin-bottom: 30px;
}

.login-form :deep(.el-input__inner) {
  height: 45px;
  border-radius: 8px;
}

.login-btn {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  font-size: 16px;
  margin-top: 10px;
}

.login-footer {
  text-align: left;
  color: #909399;
  font-size: 12px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .login-content {
    padding: 20px;
  }
  
  .login-header h1 {
    font-size: 20px;
  }
  
  .subtitle {
    font-size: 12px;
  }
}
</style> 